export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/picture-of-you.b930d7b92f771d9006a5673f9ae1716c.svg";